import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { socketClient } from '@/api/socket';

export const useRealtimeErrors = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    const socket = socketClient.getSocket();

    if (!socket) {
      return;
    }

    const handleNewError = (data: any) => {
      console.log('New error received via WebSocket:', data);
      queryClient.invalidateQueries({ queryKey: ['errors'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'metrics'] });
    };

    const handleErrorResolved = (data: any) => {
      console.log('Error resolved via WebSocket:', data);
      queryClient.invalidateQueries({ queryKey: ['errors'] });
      queryClient.invalidateQueries({ queryKey: ['dashboard', 'metrics'] });
    };

    socket.on('error:new', handleNewError);
    socket.on('error:resolved', handleErrorResolved);

    return () => {
      socket.off('error:new', handleNewError);
      socket.off('error:resolved', handleErrorResolved);
    };
  }, [queryClient]);
};
